// extracted by mini-css-extract-plugin
module.exports = {"form":"ContractorsRegistrationForm_form__BFR7-"};